import {useBasketStore, useProductStore} from './useStore'

export const useBasketItem = (itemId: string) => {
  const {basket} = useBasketStore()
  const {productsById} = useProductStore()

  const item = basket?.productItems?.find((_item) => _item.productId === itemId)
  const product = item ? productsById[item.productId!] : null
  const quantity = item?.quantity || 0

  return {item, product, quantity}
}
